export default (baseId) => `toggler_${baseId}`;
